import styled from 'styled-components';

import Link from '~/src/common/components/Link';

/** Container pour une seule catégorie, son header et ses sous catégories */
export const Container = styled.div`
  display: flex;
  overflow: hidden;
  flex-direction: column;
`;

/**
 * Le header d'une catégorie est un lien. Il contient image, nom, et tag
 * Pour la cohérence, le pointeur n'est en mode lien que sur les enfants
 */
export const Head = styled(Link)`
  display: inline-flex;
  gap: 8px;
  align-items: center;
  cursor: default;

  & > * {
    cursor: pointer;
  }
`;

/** Image de la catégorie */
export const Image = styled.img`
  flex: 0 0 auto;
  display: block;
  width: 48px;
  height: 48px;
  object-fit: cover;
  border-radius: 8px;
`;

/** Le nom de la catégorie */
export const Name = styled.strong`
  font-size: 18px;
  font-weight: 500;
  color: ${({ theme }) => theme.palette.primary};

  &:hover {
    color: ${({ theme }) => theme.palette.common.PRIMARY_HOVER};
  }

  /* Si le nom de la catégorie est suivi d'un sticker, alors le style
     de celui-ci est surchargé afin qu'il soit entièrement visible */
  + span {
    overflow: visible;
  }
`;

/** Lien vers la catégorie, sous la liste des sous catégories */
export const More = styled(Link)`
  display: flex;

  gap: 8px;
  align-self: flex-start;
  align-items: center;

  font-size: 14px;
  font-weight: 500;
  line-height: 28px;
  color: ${({ theme }) => theme.palette.primary};
`;
